import WizardCard from "../../components/WizardCard"
import useMediaQuery from "../../hooks/useMediaQuery"

const GovtIntroductionHowCanNCXHelpYouCard = () => {
  const isMaxWidthSm = useMediaQuery("(max-width: 664px)")

  return (
    <WizardCard paddingSize={isMaxWidthSm ? "sm" : "lg-y"}>
      <div className="flex flex-col">
        <h2 className="text-2xl font-display font-medium leading-[124%] tracking-[0.48px]">
          How can NCX help you
        </h2>

        <p className="font-body leading-[140%] tracking-[0.32px] mt-6">
          We are a dedicated team building a better way for landowners to build
          income streams from their land and stronger, healthier forests for the
          future.
        </p>

        <div className="bg-grass-50 border-[3px] border-[#416952] rounded-sm px-[25px] py-[30px] mt-[18px]">
          <h3 className="font-body font-bold leading-[24px] tracking-[0.96px]">
            We build a personalized plan for you and help you take action.
          </h3>

          <p className="text-sm font-body leading-[140%] tracking-[0.28px]">
            We offer a trusted voice and sounding board who will help you
            understand your risks and the tradeoffs of different plan actions.
          </p>

          <h3 className="font-body font-bold leading-[24px] tracking-[0.96px] mt-4">
            We sort through thousands of grants & subsidies to find the right
            ones for you.
          </h3>

          <p className="text-sm font-body leading-[140%] tracking-[0.28px]">
            This may include state specific tax credits, cost share assistance
            programs, or timber replanting and carbon programs.
          </p>

          <h3 className="font-body font-bold leading-[24px] tracking-[0.96px] mt-4">
            Act as your personal support team, all managed from your desktop or
            phone.
          </h3>

          <p className="text-sm font-body leading-[140%] tracking-[0.28px]">
            We assess your land, plan with you to maximize your land goals, and
            help you implement that plan, leaving you more time to enjoy it.
          </p>
        </div>
      </div>
    </WizardCard>
  )
}

export default GovtIntroductionHowCanNCXHelpYouCard
